import React from 'react';
import cx from 'classnames';

import {Button} from '@deviceinsight/ng-ui-basic-components';

import {WorkingShiftDay, KpiPeriodTypeType} from '../kpiUtils';

const weekdays: Array<{dayOfWeek: WorkingShiftDay; label: string}> = [
	{
		dayOfWeek: 1,
		label: 'Mon'
	},
	{
		dayOfWeek: 2,
		label: 'Tue'
	},
	{
		dayOfWeek: 3,
		label: 'Wed'
	},
	{
		dayOfWeek: 4,
		label: 'Thu'
	},
	{
		dayOfWeek: 5,
		label: 'Fri'
	},
	{
		dayOfWeek: 6,
		label: 'Sat'
	},
	{
		dayOfWeek: 7,
		label: 'Sun'
	}
];
type Props = {
	days: WorkingShiftDay[] | null | undefined;
	onDaysChange: (arg0: WorkingShiftDay[]) => void;
	periodType: KpiPeriodTypeType | null | undefined;
};
export default function WeekdaysPicker({days, onDaysChange, periodType}: Props) {
	// Initialize days if not yet defined
	if (!days) {
		onDaysChange([]);
	}

	// The default value is for flow, days will always be at least an empty array at this point
	const daysLocal = days || [];

	function toggleDay(day: WorkingShiftDay) {
		if (daysLocal.includes(day)) {
			onDaysChange(daysLocal.filter((d) => d !== day));
		} else {
			onDaysChange([...daysLocal, day]);
		}
	}

	return (
		<div className={periodType === 'DAY' ? 'weekdays-picker-single-day-selected' : 'weekdays-picker'}>
			{weekdays.map(({dayOfWeek, label}) => (
				<Button
					key={dayOfWeek}
					onClick={() => toggleDay(dayOfWeek)}
					className={cx({
						active: daysLocal.includes(dayOfWeek)
					})}>
					{label}
				</Button>
			))}
		</div>
	);
}
